import React, { memo } from 'react';
import TooltipV2 from '@/components/TooltipV2';
import Icon, { IconName } from '@/components/atoms/Icon';
import Button from '@/components/atoms/Button/Button';

function PlayerTimelineButton({
  tooltipTitle,
  buttonId,
  onClick,
  iconName,
  isDisabled
}: {
  tooltipTitle: string;
  buttonId: string;
  onClick: () => void;
  iconName: IconName;
  isDisabled?: boolean;
}) {
  return (
    <TooltipV2
      tooltipId={buttonId}
      tooltipContent={tooltipTitle}
      noArrow
      tooltipElement={
        <Button
          className="h-[42px] w-[42px] p-0"
          variation="checkbox"
          trackingId={buttonId}
          onClick={onClick}
          buttonSize="base"
          disabled={isDisabled}
        >
          <Icon name={iconName} className="h-[15px] w-[15px] p-0" stroke={2.5} />
        </Button>
      }
    />
  );
}

export default memo(PlayerTimelineButton);
